import { render, staticRenderFns } from "./EcosurveyIngestionSchemaManage.vue?vue&type=template&id=e55ce7ea&scoped=true"
import script from "./EcosurveyIngestionSchemaManage.vue?vue&type=script&lang=js"
export * from "./EcosurveyIngestionSchemaManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e55ce7ea",
  null
  
)

export default component.exports